module.exports = __webpack_public_path__ + "img/cinza - azul.495d5d1c.svg";